$(document).ready(function () {
  $(window).on("load", function(e) {
    const url = new URLSearchParams(window.location.search);
    const currentVariant = url.get('variant');

    if (!currentVariant) {
      return;
    }

    const allVariants = document.querySelectorAll('.product_main_options .product_option');
    allVariants.forEach(variant => {
      const input = variant.querySelector('input');
      input.checked = input.value === currentVariant;
    });
    // console.log('currentVariant', currentVariant);
  });

  $(document).on('change', '.product_option input[name="size"]', function (e) {
    //change size
    const prevChecked = $(this).parent().parent().find('.product_option input[name="size"][checked]');
    const selectedElement = $(this);
    const mainProductId = selectedElement.data('product-id');
    const productId = selectedElement.val();
    const price = selectedElement.data("price");
    const available = selectedElement.data('available');
    const comparePrice = selectedElement.data("compare-price");
    const lessThenQuantity = selectedElement.data('less-then-quantity');
    const lessThen = available && selectedElement.hasClass('less-then');

    prevChecked.removeAttr('checked');
    selectedElement.attr('checked', 'checked');

    // BIS.create('onekill731@gmail.com', productId, mainProductId);

    if (lessThen) {
      $('.product_left').css('display', 'flex');
    } else {
      $('.product_left').css('display', 'none');
    }

    $('.product_left_quantity').text(lessThenQuantity);
    if (lessThenQuantity < 3 && lessThenQuantity > 0) {
      $('.product_left_only').css('display', 'inline');
    } else {
      $('.product_left_only').css('display', 'none');
    }

    if (window.location.pathname.includes('products')) {
      const url = new URL(window.location);
      url.searchParams.set("variant", productId);
      history.pushState(null, null, url);
    }

    const btnTranslate = $('input[name="btn_translate"]').val();
    const btnTranslateSoldOut = $('input[name="btn_translate_soldout"]').val();
    
    if (available === false) {
      $('[data-add-to-cart]').css('display', 'none');
      $('.klaviyo-bis-trigger').removeClass('hidden');
      $('.klaviyo-bis-trigger').addClass('visible');
      $('[data-add-to-cart]').html(btnTranslateSoldOut).attr('aria-label', btnTranslateSoldOut);
      $('[data-notify-btn]').addClass('_active');
    } else {
      $('[data-add-to-cart]').css('display', 'block');
      $('.klaviyo-bis-trigger').removeClass('visible');
      $('.klaviyo-bis-trigger').addClass('hidden');
      $('[data-add-to-cart]').html(btnTranslate).attr('aria-label', btnTranslate);
      $('[data-notify-btn]').removeClass('_active');
    }

    $('.price__without-sale .exemptify_price').text(price);
    $('.price__with-sale .exemptify_price').text(price);
    $('.price__with-sale .sale_price').text(comparePrice);

    if (available) {
      $('a#BIS_trigger').hide();
    } else {
      $('a#BIS_trigger').show().attr('data-variant-id', productId);
    }

    if (!comparePrice) {
      $(".product_main_prices").addClass(
        "price--sold-out price--on-sale price--old-price-hidden price--unit-available"
      );
      $(".product_main_prices").removeClass("price--on-sale");

      $('.price__with-sale').removeClass('show');
      $('.price__without-sale').addClass('show');

      return;
    }

    if (comparePrice) {
      $(".product_main_prices").removeClass(
        "price--sold-out price--on-sale price--old-price-hidden price--unit-available"
      );
      $(".product_main_prices").addClass("price--on-sale");

      $('.price__with-sale').addClass('show');
      $('.price__without-sale').removeClass('show');
      return true;
    }

    $(".product_main_prices .price__regular div").html(price);
    $(".product_main_prices").removeClass(
      "price--sold-out price--on-sale price--old-price-hidden price--unit-available"
    );
  });

  $('[data-notify-btn]').on('click', function(e) {
    $('.notify_overlay, .notify_popup').addClass('_active');
    $('body').addClass('no_scroll');
  });

  $( document ).on( 'click', '.notify_popup_close, .notify_overlay', function() {
    $( '.notify_popup, .notify_overlay' ).removeClass( '_active' );
    $('body').removeClass('no_scroll');

    $('#notify_popup .notify_popup_message_block').removeClass('_active error').html();
    $('#notify_popup .notify_popup_input').val('');
  });

  function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    return emailRegex.test(email);
  }

  $('#notify_popup .notify_popup_btn').on('click', function(e) {
    $('#notify_popup .notify_popup_message_block').removeClass('_active error').html();
    const email = $('#notify_popup .notify_popup_input').val();

    if (!validateEmail(email)) {
      $('#notify_popup .notify_popup_message_block').addClass('_active error').html('Invalid email address');
      return false;
    }

    const productId = $('.product_option input[name="size"]:checked').data('product-id');
    const variantId = $('.product_option input[name="size"]:checked').val();
    
    BIS.create(email, variantId, productId);

    $('#notify_popup .notify_popup_input').val('');
    $('#notify_popup .notify_popup_message_block').addClass('_active').html('Your notification has been registered');
  });

  // $('[data-add-to-cart]').on('click', function(e) {
  //   e.preventDefault();
  //   const available = $('.product_option input[name="size"]:checked').data('available');
  //   if (available === false) return false;

  //   $('._loader').removeClass('_hide');
  //   $('[data-add-to-cart]').hide();
  //   const productId = $('.product_option input[name="size"]:checked').val();

  //   $.ajax({
  //     url: '/cart/add.js',
  //     type: 'POST',
  //     dataType: 'json',
  //     data: {
  //       id: productId,
  //       quantity: 1 // кличество если нужно будет
  //     },
  //     success: (data) => {
  //       updateCartItemCount();
  //       updateCartContents();

  //       $('._loader').addClass('_hide');
  //       $('[data-add-to-cart]').show();
  //     },
  //     error: (error) => {
  //       console.log('error');
  //       console.log(error);

  //       $('._loader').addClass('_hide');
  //       $('[data-add-to-cart]').show();
  //     }
  //   })
  // });

  // function updateCartItemCount() {
  //   $.ajax({
  //       url: '/cart.js',
  //       dataType: 'json',
  //       success: function(cartData) {
  //           var itemCount = cartData.item_count;
  //           // Обновляем отображение количества товаров в шапке
  //           $('.header_cart_counter').text(itemCount);
  //           $('.header_cart_counter').removeClass('_hidden');
  //       },
  //       error: function(error) {
  //           console.error('Ошибка при получении данных о корзине:', error);
  //       }
  //   });
  // }

  // function updateCartContents() {
  //   $.ajax({
  //     url: 'cart?section_id=cart-popup',
  //     success: function(cart) {
  //       const html = $(cart);
  //       const cartPopup = $('#popup_cart');

  //       const targetElement = cartPopup.find('.popup_cart_wrap');
  //       const sourceElement = html.find('.popup_cart_wrap');

  //       if (targetElement.length > 0 && sourceElement.length > 0) {
  //         targetElement.replaceWith(sourceElement);
  //       }

  //       openCart();
  //     },
  //     error: function(error) {
  //       console.error('Ошибка при получении данных о корзине:', error);
  //     }
  //   })
  // }

  // function openCart() {
  //   $("body").addClass("no_scroll");
  //   $(".cart_overlay").addClass("_active");
  //   $("#popup_cart").addClass("_active");
  // }
  
});